export default __webpack_public_path__ + "images/f0b7b20e36bb3000cee3d5e0ff849692-administrating_medication.svg";